import { Link, useLocation } from "react-router-dom";
import { Button } from "../components/ui/Button";
import { Icon } from "../components/ui/Icon";

const quickLinks = [
  { to: "/dashboard", icon: "tabler:layout-dashboard", label: "Dashboard" },
  { to: "/profile", icon: "tabler:user", label: "Profile" },
  { to: "/settings/general", icon: "tabler:settings", label: "Settings" },
  { to: "/system/changelog", icon: "tabler:file-text", label: "Changelog" },
];

export const NotFoundPage = () => {
  const { pathname } = useLocation();

  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
      {/* Large 404 display */}
      <div className="mb-6 select-none">
        <span className="text-[10rem] font-black leading-none tracking-tighter text-foreground/[0.04]">
          404
        </span>
      </div>

      {/* Heading + description */}
      <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground leading-relaxed">
        The path{" "}
        <code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground/70">
          {pathname}
        </code>{" "}
        doesn't match any page in the dashboard.
      </p>

      {/* Primary action */}
      <Link to="/dashboard" className="mt-8">
        <Button
          variant="primary"
          size="sm"
          icon={<Icon icon="tabler:arrow-left" size={16} />}
        >
          Back to Dashboard
        </Button>
      </Link>

      {/* Quick links */}
      <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
        {quickLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="group flex items-center gap-2 rounded-lg border border-border/50 bg-card/60 px-4 py-2.5 text-sm text-muted-foreground transition-all hover:border-primary/30 hover:bg-primary/5 hover:text-foreground"
          >
            <Icon icon={link.icon} size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
            {link.label}
          </Link>
        ))}
      </div>
    </div>
  );
};
